import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { searchSelectors } from 'store/search';
import { useHistory } from 'react-router';
import { StyledCustomCollection } from './StyledComponents';
import { SearchPlaceholder } from './SearchPlaceholder';
import { isEmpty } from 'lodash';

interface ISearchResult {
  onContentFocus: (item: unknown, index: number) => unknown;
}

const SearchResult: React.FC<ISearchResult> = ({ onContentFocus }) => {
  const videos = useSelector(searchSelectors.selectSearchVOD);
  const channels = useSelector(searchSelectors.selectSearchChannels);
  const programs = useSelector(searchSelectors.selectSearchPrograms);
  const history = useHistory();

  const getCollections = useMemo(() => {
    let collection = [];

    if (!isEmpty(videos)) {
      collection = [
        {
          contentType: 'VOD_ASSET',
          data: videos,
          contentSize: '20',
          name: 'Movies',
          id: 'movie',
          title: 'Movies',
        },
      ];
    }

    if (!isEmpty(channels)) {
      collection = [
        ...collection,
        {
          contentType: 'CHANNEL',
          data: channels,
          contentSize: '20',
          name: 'Channels',
          id: 'channel',
          title: 'Channels',
        },
      ];
    }

    if (!isEmpty(programs)) {
      collection = [
        ...collection,
        {
          contentType: 'PROFILE',
          data: programs,
          contentSize: '20',
          name: 'Programs',
          id: 'program',
          title: 'Programs',
        },
      ];
    }

    return collection;
  }, [videos, channels, programs]);

  const onContentEnter = useCallback(
    (item) => {
      const itemType = item.asset_type || item.type;
      const itemID = item.asset_id || item.id;
      switch (itemType) {
        case 'movie':
          history.push(`/details/${itemType}/${itemID}`);
          break;
        case 'channel':
          history.push(`/player/channel/${itemID}`);
          break;

        default:
          break;
      }
    },
    [history],
  );

  return !isEmpty(getCollections) ? (
    <StyledCustomCollection
      onContentFocus={onContentFocus}
      collections={getCollections}
      onContentEnter={onContentEnter}
    />
  ) : (
    <SearchPlaceholder description="Nothing to show here" />
  );
};

export default SearchResult;
